<template>
    <CardCourse
        v-bind="{ ...$props, ...$attrs }"
        mode="stack"
        class="card-preview-course py-4 h-30"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CardCourse from '@/components/CardCourse';

/**
 * This CardPreviewCourse component is a special adjustment of the CardCourse component with a fixed height.
 */
export default defineComponent({
    name: 'CardPreviewCourse',
    components: {
        CardCourse,
    },
    inheritAttrs: false,
    props: {
        /**
         * Name of the course
         */
        courseName: {
            type: String,
            required: true,
        },
    }
});
</script>

<style lang="scss" scoped>
.card-preview-course {
    :deep(.content-area) {
        @apply truncate mt-1;
    }

    :deep(.tag-list) {
        @apply pb-0.5 pt-2;
    }
}
</style>
